import React, { createContext, useState, useContext, useEffect } from 'react';
import { adminAuthAPI } from './api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin is logged in on mount
    const token = localStorage.getItem('quizzler_admin_token');
    if (token) {
      adminAuthAPI.getMe()
        .then((response) => {
          setAdmin(response.data.admin);
        })
        .catch(() => {
          localStorage.removeItem('quizzler_admin_token');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await adminAuthAPI.login(email, password);
    localStorage.setItem('quizzler_admin_token', response.data.token);
    setAdmin(response.data.admin);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('quizzler_admin_token');
    setAdmin(null);
  };

  const value = {
    admin,
    loading,
    login,
    logout,
    isAuthenticated: !!admin,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
